import { Builder } from '@builder.io/react';

import { BlogCategorySearch } from './blog-category-search';

Builder.registerComponent(BlogCategorySearch, {
  name: 'BlogCategorySearch',
  friendlyName: 'Blog Category Search',
  description:
    'A category filter component for searching partner news articles by category',
  image:
    'https://cdn.builder.io/api/v1/image/assets%2F3124f13d16c344a781aa2e5bdbc00183%2Fc79f51fe0e3c498f9d75078be387b316',
  inputs: [
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Browse by Category',
      helperText: 'Title displayed above the category buttons',
    },
    {
      name: 'categories',
      type: 'list',
      subFields: [
        {
          name: 'title',
          type: 'string',
          required: true,
          helperText: 'Display name for the category button',
        },
        {
          name: 'value',
          type: 'string',
          required: true,
          helperText:
            'Category value to search for (leave empty for "View all")',
        },
      ],
      defaultValue: [
        { title: 'View all', value: '' },
        {
          title: 'Industry News & Regulations',
          value: 'Industry News & Regulations',
        },
        { title: 'Technology & Tools', value: 'Technology & Tools' },
        { title: 'Partner Resources', value: 'Partner Resources' },
        { title: 'Seasonal Planning', value: 'Seasonal Planning' },
        { title: 'Product Updates', value: 'Product Updates' },
        { title: 'Case Studies', value: 'Case Studies' },
        { title: 'Agency Growth', value: 'Agency Growth' },
        { title: 'Brand & Culture', value: 'Brand & Culture' },
        { title: 'Lead Generation', value: 'Lead Generation' },
      ],
      helperText: 'List of categories to display as clickable buttons',
    },
    {
      name: 'className',
      type: 'string',
      helperText: 'Additional CSS classes for custom styling',
      advanced: true,
    },
    {
      name: 'isConsumerNews',
      friendlyName: 'Consumer News',
      type: 'boolean',
      defaultValue: false,
    },
  ],
  defaultStyles: {
    display: 'block',
    width: '100%',
  },
});
